export default "__VITE_ASSET__BCOkMYdJ__"